// Copyright Epic Games, Inc. All Rights Reserved.

/**
 * Session statistics
 */
export class SessionStats {
    runTime: string;
    controlsStreamInput: string;
    videoEncoderAvgQP: number;
}
